export default __webpack_public_path__ + "static/media/radio_button_disabled.366b4a8c.svg";